<template>
    <BaseModal :isOpen="isModalOpen" @Close="handleCloseModal" :modalTitle="this.$t('pages.DeviceImportList.Source.ReturnToCommunStock')" :labels="labels">
        <div>
            <div class="form-group">
                <label for="fileInput" class="customButton"><i
                        class="scf-dSquare"></i>{{ this.$t(`${translationNodes}ChooseFile`) }}</label>
                <input type="file" id="fileInput" ref="fileInput" @change="handleFileChange" hidden accept="text/csv">

                <div class="fileContainer">
                    <div class="inputResult">
                        <span v-if="selectedFile" class="selectedFile-name">{{selectedFile.name}}</span>
                    </div>
                </div>
            </div>

            <!-- Progress Bar -->
            <ProgressBar v-if="progress >= 0 && !errorMessages" :progress="progress" />

            <div class="formError" v-if="errorMessages">
                <div v-for="errorCode in errorMessages" :key="errorCode">
                     <div :class="errorCode === 'ProcessingFile' ? 'success-message' : 'error-message'">
                        <div v-html="showErrorMessage(errorCode)" ></div>
                    </div>
                </div>
            </div>
        </div>

    </BaseModal>
</template>

<script>
    let translationNodes = "components.molecules.returnToCommonStockModal.";

    import MainService from "../../services/MainService";
    import BaseModal from '../atoms/BaseModal';
    import ProgressBar from '../atoms/ProgressBar';
    import Helper from "@/Utils/Helper";


    export default {
        name: "ReturnToCommonStockModal",
        inject: ["routePrefix", "accessToken", "currentScope"],

        components: {
            BaseModal,
            ProgressBar
        },

        watch: {
            currentScope(newVal) {
                if (newVal) {
                    this.mainService = new MainService(this.$jwt.token, newVal);
                }
            },
            accessToken(newVal) {
                if (newVal) {
                    this.mainService = new MainService(newVal, this.currentScope);
                }
            },

            selectedFile(newVal, oldValue) {
                if(oldValue && newVal && newVal.name !== oldValue.name) {
                    this.errorMessages = null;
                }
            }

        },

        data() {
            return {
                hasRole: this.$jwt.hasAtLeastOneRole([
                    "dm-administrator",
                ]),
                recordId: null,
                isSuccess: false,
                isLoading: false,
                progress: -1,
                errorMessages: null,
                translationNodes: translationNodes,
                selectedFile: null,
                mainService: new MainService(this.$jwt.token, this.$jwt.scope),
            }
        },

        computed: {
            labels() {
                return [{
                        key: 'save',
                        label: this.$t(`${translationNodes}Submit`),
                        method: this.handleOnValidate,
                        class: "btn-success",
                        isDisabled: this.selectedFile === null || (this.errorMessages && this.errorMessages.length > 0)
                    },
                    {
                        key: 'cancel',
                        label: this.$t(`${translationNodes}Cancel`),
                        method: this.handleOnCancel,
                        class: "btn-danger",
                        isDisabled: false
                    }
                ]
            },
            canAccessFileProcessing() {
                // Depend on accessToken so roles are evaluated after token refresh
                void this.accessToken;
                return this.$jwt.hasAtLeastOneRole(["dm-administrator", "dm-assets-read"]);
            }
        },

        methods: {
            showErrorMessage(errorCode) {
                if(errorCode === "FileAlreadyProcessed" || errorCode === "ProcessingFile") {
                    const prefix = Helper.ComputeRoutePrefix(this.routePrefix);
                    const detailsLink = this.canAccessFileProcessing
                        ? `<a href='${prefix}/DmPortal/FileProcessingDetails/${this.currentScope}/${this.recordId}' target="_blank">Voir les details</a>`
                        : "";
                    return `<div>
                        ${errorCode === 'ProcessingFile' ? '&#10003;' : '&#9888;'} &nbsp;
                        <span>${this.$t(this.translationNodes + errorCode)}</span>
                        ${detailsLink ? ` &nbsp; ${detailsLink}` : ""}
                        </div>`
                }

                return this.$t(`${this.translationNodes}${errorCode}`);
            },
            handleCloseModal() {
                this.resetForm();
                this.$emit('closeModal');
            },
            handleFileChange(event) {
                this.selectedFile = event.target.files[0];
            },
            handleOnCancel() {
                // Logique pour g�rer l'annulation
                this.resetForm();
                this.$emit('closeModal');
            },
            resetForm() {
                this.recordId = null;
                this.isSuccess = false;
                this.isLoading = false;
                this.progress = -1;
                this.errorMessages = null;
                this.selectedFile = null;
            },
            handleOnValidate() {
                let formdata = new FormData();
                formdata.append("toCommonStockFile", this.selectedFile);
                this.handleUploadFile(formdata);
            },
            async handleUploadFile(data) {
                this.loading = true;
                try {
                    const response = await this.mainService.UploadFile(data, this.currentScope, (
                    progress) => {
                        this.progress = progress;
                    });

                    if (response && response.status === 200) {
                        const {
                            success,
                            errors,
                            result
                        } = response.data

                        this.errorMessages = errors
                        this.isSuccess = success
                        this.recordId = result

                        if(success) {
                            this.errorMessages = ["ProcessingFile"]
                            // this.$router.push({
                            //     path: `${this.routePrefix}/DmPortal/FileProcessingDetails/${this.currentScope}/${result}`,
                            // });
                        }

                    } else {
                        this.errorMessages = ["ServerError"];
                    }

                } catch (error) {
                    this.errorMessages = ["ServerError"];
                    console.error('There was a problem with the fetch operation:', error);
                } finally {
                    this.loading = false;
                }
            }
        },

        props: {
            isModalOpen: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .success-message {
        color: #198754;
        font-size: 0.9em;
        margin-top: 5px;
    }
    .error-message {
        color: red;
        font-size: 0.9em;
        margin-top: 5px;
    }

    .customButton {
        padding: 5px 10px;
        background-color: #eeeeee;
        color: #1d2753;
        border: none;
        cursor: pointer;
        border-radius: 5px;
        font-size: .675em;
        transition: background-color 0.3s;
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;

        // Ellipsis
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .customButton i {
        margin-right: 5px;
    }

    .customButton:hover {
        background-color: #d4d4d4;
    }

    .form-group {
        min-width: 20vw;
        display: flex;
        align-items: center;
        font-size: 1.2em;
        /* Centrer verticalement les �l�ments */
    }

    .formError {
        font-size: .875rem;
        margin-top: 5px;
    }

    .customButton,
    .inputResult {
        margin-right: 10px;
        /* Espacement entre les �l�ments */
    }

    /* Ajout d'un style pour .fileContainer pour aligner horizontalement les �l�ments � l'int�rieur */
    .fileContainer {
        display: flex;
        align-items: center;
        min-width: 60%;
        /* largeur d�finie � 70% */
        border-radius: 5px;
        background-color: #f4f6fb;
        padding: 5px 10px;
    }

    .fileContainer .inputResult {}

    .fileContainer .inputResult>span {
        font-size: .675em;
    }

    .btn-submit {
        background-color: "#aadc14";
    }

    .btn-cancel {
        background-color: "#e04644";
    }
</style>
